import { render } from "./MinorCategoryManager.vue?vue&type=template&id=5d51532a&scoped=true"
import script from "./MinorCategoryManager.vue?vue&type=script&lang=js"
export * from "./MinorCategoryManager.vue?vue&type=script&lang=js"

import "./MinorCategoryManager.vue?vue&type=style&index=0&id=5d51532a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d51532a"]])

export default __exports__